import React from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

export const TaskListHeader: React.FC<{
  headerHeight: number
  rowWidth: string
  fontFamily: string
  fontSize: string
}> = ({ headerHeight }) => {
  return (
    <div
      className={styles.header}
      style={{
        height: headerHeight
      }}
    >
      <div className={classnames(styles.headerItem, styles.name)}>Task name</div>

      <div className={styles.headerItem}>Start</div>

      <div className={styles.headerItem}>Finish</div>

      <div className={styles.headerItem}>Assignees</div>
    </div>
  )
}
